import { Component, OnInit } from "@angular/core";
import { TeamsService } from "../teams.service";
import { ActivatedRoute, Router } from "@angular/router";

import { environment } from "../../../environments/environment";
import { LoaderService } from "src/app/loader/loader.service";
import * as moment from "moment";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Equipe } from "../models/equipe";

@Component({
  selector: "app-teams-details",
  templateUrl: "./teams-details.component.html",
  styleUrls: ["./teams-details.component.scss"],
})
export class TeamsDetailsComponent implements OnInit {
  env;
  team: Equipe;

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};
  teamType: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private teamsService: TeamsService,
    private loaderService: LoaderService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.setCompaniesDropdown();
    this.getTeam(this.route.snapshot.paramMap.get("id"));
  }

  async getTeam(id: string) {
    const loader = await this.loaderService.notifica({
      title: "Buscando equipe...",
      date: moment().toISOString(),
      type: "loading",
    });

    this.team = await this.teamsService.getTeam(id).toPromise();

    this.teamType = this.team.membros[0].novoPerfil.nome === "Virtus Service - APP" ? "Serviços" : "Vendas";

    this.filterCompaniesByUserPermissions();

    loader.dismiss();
  }

  private filterCompaniesByUserPermissions() {
    this.team.empresas = this.team.empresas.filter(company => {
      for (let userCompany of this.env.user.empresas) {
        if (company.cnpj === userCompany.cnpj) {
          return true;
        }
      }
      return false;
    });
  }

  setCompaniesDropdown() {
    this.dropdownList = this.env.user.empresas;

    this.dropdownSettings = {
      singleSelection: false,
      idField: "cnpj",
      textField: "fantasia",
      selectAllText: "Selecionar Todos",
      unSelectAllText: "Deselecionar Todos",
      itemsShowLimit: 4,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
    };
  }

  goBack(): void {
    this.router.navigateByUrl(`/teams/${this.env.selected.cnpj}`);
  }
}
